module.exports = __webpack_public_path__ + "media/newstyle/images/icon-check-pink-9d75112534a81ed9627bd7a609850f7f.svg";